// Platform-neutral helpers for the file exports (shared by shareFile.ts and
// shareFile.web.ts callers — keep them out of the platform-split module).

const MIME_TYPES: Record<string, string> = {
  csv: 'text/csv',
  json: 'application/json',
  png: 'image/png',
  vcf: 'text/vcard',
}

/** MIME type the Android share sheet needs to offer the right apps. */
export function mimeTypeOf(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? ''
  return MIME_TYPES[extension] ?? 'application/octet-stream'
}

/** UTF-8 text → base64, to share a text export (CSV, JSON) as a file. */
export function textToBase64(text: string): string {
  return btoa(unescape(encodeURIComponent(text)))
}
